import React from 'react';
import { Clock, Users, Workflow, Headphones, MapPin, Award } from 'lucide-react';

const CompanyStrength = () => {
  const strengths = [
    {
      icon: Award,
      title: "15+ Years of Deep Expertise",
      description: "Over a decade and a half deploying IT infrastructure across manufacturing, healthcare, BFSI, retail, education, and government sectors."
    },
    {
      icon: Users,
      title: "200+ Enterprise Clients",
      description: "Trusted by leading enterprises, SMEs, government bodies, and institutions across India for mission-critical IT deployments."
    },
    {
      icon: Workflow,
      title: "Complete Project Lifecycle",
      description: "From consultation and procurement to deployment, integration, training, and ongoing maintenance — we own the entire journey."
    },
    {
      icon: MapPin,
      title: "Pan-India Service Network",
      description: "Service coverage across 50+ cities with authorized service partners ensuring fast resolution times regardless of your location."
    },
    {
      icon: Award,
      title: "Authorized OEM Partner",
      description: "Authorized partner for HP, Dell, Lenovo, Citrix, NetApp, Pure Storage, Zebra, and many more leading technology brands."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-cyan-100 rounded-full mb-4">
            <span className="text-cyan-700 font-semibold text-sm">Our Strength</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Leading Enterprises Trust Us
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Proven track record of delivering excellence in IT infrastructure and solutions
          </p>
        </div>

        {/* Strengths Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {strengths.map((strength, index) => {
            const IconComponent = strength.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 group"
              >
                <div className="mb-6 p-4 bg-gradient-to-br from-cyan-500 to-lime-500 rounded-xl inline-block group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="text-white" size={32} />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {strength.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {strength.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CompanyStrength;
